import { Component, Inject, Input, OnInit } from '@angular/core';
import { CONFIG_TOKEN } from 'core/constants';
import { IXMOptions } from 'core/interfaces';
import { MyAccountModal } from 'my-account/services/modal';
import { XmPricingComparisonModal } from 'my-account/shared/modals/pricing-comparison/pricing-comparison';
import { Subscription } from 'rxjs';
import { CimaCore, XmStore, XmStoreUtil } from 'services/index';
import { BroadbandLabels } from 'store/broadband-label/models';
import { Cms5GPlanOverview } from 'store/cms/models';
import { DiscountPromoCollection } from 'store/promotions/discount-promotion/models';

@Component({
    selector: 'xm-plan-seven-unl',
    styleUrls: ['./plan-seven-unl.scss'],
    templateUrl: './plan-seven-unl.html',
    standalone: false
})
export class XmPlanSevenUNL implements OnInit {
    @Input() public pageData: FiveGPlanOverview;
    public isBusinessUser: boolean;
    public broadbandLabelData: BroadbandLabelOverview;
    public broadbandLabelsResponse: BroadbandLabels;
    public planList: LabelDetails[] = [];
    public labelResponse: NutritionLabel[] = [];
    public labelDetails: LabelSegmentDetails;
    public planData: CmsPlanSevenUnlimitedOverviewFeatureContent;
    public promoResponse: DiscountPromoCollection;

    private cimaCore: CimaCore;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private modal: MyAccountModal;
    private modalData: CmsPricingComparisonContent;

    constructor(xmStore: XmStore, cimaCore: CimaCore, modal: MyAccountModal, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { xmStore, cimaCore, modal, config });
    }

    public ngOnInit(): void {
        this.isBusinessUser = this.cimaCore.isBusinessUser;
        this.modalData = this.pageData.comparisonModal;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<DiscountPromoCollection>(DiscountPromoCollection), (result: DiscountPromoCollection) => {
            this.promoResponse = result;
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<Cms5GPlanOverview>(Cms5GPlanOverview), (result: Cms5GPlanOverview) => {
            this.broadbandLabelData = !this.isBusinessUser ? result.planEightBroadbandLabel :result.planSevenBroadbandLabel;
            this.labelDetails = result.cbmPlanSevenBroadbandLabel.unlimited;
            this.addPromoSuffixToBroadbandPlanIds();
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<BroadbandLabels>(BroadbandLabels), ((label: BroadbandLabels) => {
            this.broadbandLabelsResponse = label;

            this.planList = this.labelDetails?.plans;
            this.planList.forEach((plan: LabelDetails) => {
                const foundLabel: NutritionLabel = this.broadbandLabelsResponse.labels.find((nutritionLabel: NutritionLabel) => nutritionLabel.planId === plan.planId);
                this.labelResponse.push(foundLabel);
            });
        })));
    }

    public openPricingModal(): void {
        this.modal.open(XmPricingComparisonModal, this.modalData);
    }

    public createImageOption(image: Image): MediaImageOptions {
        return {
            mobile: {
                base: image
            }
        };
    }

    private addPromoSuffixToBroadbandPlanIds(): void {
        if (this.broadbandLabelData?.unlimited?.plans && this.promoResponse?.isPlans8PromoEligible) {
            this.broadbandLabelData.unlimited.plans.forEach((plan: LabelDetails) => {
                if (!plan.planId.includes(':PROMO')) {
                    plan.planId = plan.planId + ':PROMO';
                }
            });
        }
    }
}
